export { categoryLinkHTML as default } from "discourse/ui-kit/helpers/d-category-link";
